module.exports = __webpack_public_path__ + "img/footimgb.d5329b7b.png";